// extracted by mini-css-extract-plugin
module.exports = {"home":"HomePage_home__1U_y8","homeHeader":"HomePage_homeHeader__mz7GJ"};